export default "__VITE_ASSET__EcDLiVe1__"